// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-logo--xXTVt{display:flex;flex-direction:row;align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header-logo": "header-logo--xXTVt"
};
export default ___CSS_LOADER_EXPORT___;
